export function emailDeleteHTML(fromEmail, fromName, accountName) {
  return `<!-- Begin HTML Content -->
        <h1> Carrier Access Cancelled <br/></h1>
        <hr style="background:#2d8cff; height: 8px; width: 60px; border-style: solid; border-color: #095484; border-width: 1px 0 0 0; border-radius: 8px;" />
        <br><br>
        ${fromName} at ${accountName} has deleted their User account on transloads.co. <br/>
        If you believe this was done by mistake, please contact this user at their email address: <br/>
        ${fromEmail} <br/>
        You can always re-activate their account by sending them a new invite from Users > Carriers.<br/>
        <br/><br/>
        <!-- End HTML Content -->`;
}
